import { useEffect, useState } from "react";
import { CommitteeMember, CommitteeMinutes, CommitteeSearchRequest } from "../../../../Component/Model/Dto/EmploymentEquity/Committee";
import { CommitteeMinutesAgenda, CommitteeType } from "../../../../Component/Model/Enum/EmploymentEquity";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { committeeMinutesSchema } from "./CommitteeMinutesValidation";
import { useAsyncDebounce } from "react-table";
import { CommitteeService } from "../../../../Component/Api/EmploymentEquity/Committee/CommitteeService";
import { offsetTimezone } from "../../../../Component/Model/helpers";
import { toast } from "react-toastify";
import { Autocomplete, Box, Dialog, DialogActions, DialogContent, FormControl, Grid, IconButton, InputAdornment, Stack, TextField } from "@mui/material";
import { CustomDialogTitle } from "../../../Common/Custom/CustomDialogTitle";
import { MDBox } from "../../../../Component/Common/Components/MDBox";
import { LoadingButton } from "@mui/lab";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { SupportingDocuments } from "../../../Common/SupportingDocuments/SupportingDocuments";
import { MDButton } from "../../../../Component/Common/Components/MDButton";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import CloseIcon from '@mui/icons-material/Close';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { getDateWithoutTime } from "../../../../Helpers/DateFormatter";
import { CommitteeMinutesSection } from "../../../../Component/Common/Constants/UserActivityTrackingSections";
import { UserActivityService } from "../../../../Component/Api/UserActivity/UserActivityService";
import { UserActivityActionType } from "../../../../Component/Model/Enum/BEE123Enums";
import { ValidatedMobileDatePicker } from "../../../../Component/Common/Components/ValidatedMobileDatePicker/ValidatedMobileDatePicker";

interface IProps {
    id?: string;
    scorecardId: string;
    link: string;
    previewPopup: boolean;
    committeeType: CommitteeType;
    handleCancel: () => void;
    refreshTable: () => void;
    setMinutesId: (id: string) => void;

}

const agendaItemOptions: CommitteeMinutes.Agenda[] = [
    {
        agenda: CommitteeMinutesAgenda.Opening_and_welcome,
        agendaDescription: "Opening and welcome",
        agendaText: null
    },
    {
        agenda: CommitteeMinutesAgenda.Attendance_register,
        agendaDescription: "Attendance register",
        agendaText: null
    },
    {
        agenda: CommitteeMinutesAgenda.EE_Reports_Review,
        agendaDescription: "EE Reports Review",
        agendaText: null
    },
    {
        agenda: CommitteeMinutesAgenda.Monitoring_and_Evaluation_Feedback_from_Committee_Members_per_level,
        agendaDescription: "Monitoring and Evaluation Feedback from Committee Members per level",
        agendaText: null
    },
    {
        agenda: CommitteeMinutesAgenda.Committee_Constitution_Review_and_Sign_off,
        agendaDescription: "Committee Constitution Review & Sign off",
        agendaText: null
    },
    {
        agenda: CommitteeMinutesAgenda.Barriers_Analysis,
        agendaDescription: "Barriers Analysis",
        agendaText: null
    },
    {
        agenda: CommitteeMinutesAgenda.Numerical_Analysis,
        agendaDescription: "Numerical Analysis",
        agendaText: null
    },
    {
        agenda: CommitteeMinutesAgenda.EE_Plan_Development_Communication_and_Review,
        agendaDescription: "EE Plan Development Communication & Review",
        agendaText: null
    },
    {
        agenda: CommitteeMinutesAgenda.Quarterly_Review,
        agendaDescription: "Quarterly Review",
        agendaText: null
    },
    {
        agenda: CommitteeMinutesAgenda.EE_Report_Review_presubmission,
        agendaDescription: "EE Report Review pre-submission (excluding EEA4)",
        agendaText: null
    },
    {
        agenda: CommitteeMinutesAgenda.General,
        agendaDescription: "General",
        agendaText: null
    },
    {
        agenda: CommitteeMinutesAgenda.Closing_and_date_for_next_meeting,
        agendaDescription: "Closing and date for next meeting",
        agendaText: null
    },
    {
        agenda: CommitteeMinutesAgenda.Other,
        agendaDescription: "Other",
        agendaText: null
    }
]

export const CommitteeMinutesModal = (props: IProps) => {

    const [documentsPopUp, setDocumentsPopUp] = useState<boolean>(false);
    const [minutesId, setMinutesId] = useState<string | undefined>(props.id);
    const [attendeeMemberSearchValue, setAttendeeMemberSearchValue] = useState<string>("");
    const [apologyMemberSearchValue, setApologyMemberSearchValue] = useState<string>("");
    const [attendeeMembersData, setAttendeeMembersData] = useState<CommitteeMember.DtoIn[]>([]);
    const [apologiesMembersData, setApologiesMembersData] = useState<CommitteeMember.DtoIn[]>([]);
    const [attendeesData, setAttendeesData] = useState<CommitteeMember.DtoIn[]>([]);
    const [apologiesData, setApologiesData] = useState<CommitteeMember.DtoIn[]>([]);
    const [enterAgendaItem, setEnterAgendaItem] = useState<boolean>(false);
    const [agendaItemName, setAgendaItemName] = useState<string>("");

    const { control, reset, handleSubmit, formState: { errors, isSubmitting }, setValue, getValues } = useForm<CommitteeMinutes.DtoOut>({
        mode: 'all',
        defaultValues: {
            scorecardId: props.scorecardId,
            committeeType: props.committeeType,
            date: new Date(getDateWithoutTime(new Date()).toDateString()),
            agendaItems: []
        },
        resolver: yupResolver(committeeMinutesSchema)
    });

    const attendeesMembersSearchRequest: CommitteeSearchRequest = {
        pageNumber: 1,
        pageSize: 20,
        scorecardId: props.scorecardId,
        columnSortOptions: [],
        committeeType: props.committeeType,
        searchValue: attendeeMemberSearchValue
    };
    const aplogiesMembersSearchRequest: CommitteeSearchRequest = {
        pageNumber: 1,
        pageSize: 20,
        scorecardId: props.scorecardId,
        columnSortOptions: [],
        committeeType: props.committeeType,
        searchValue: apologyMemberSearchValue
    };

    const fetchAttendeeMembersData = useAsyncDebounce(async() => {
        try {
            let resp = await CommitteeService.SearchMembers(attendeesMembersSearchRequest);
            if (resp.data) {
                setAttendeeMembersData(resp.data.results);
                if(resp.data.results.length === 0){
                    toast.error("No Committee Members found");
                }
            }
        } catch (error) {
            console.log(error);
        } 
    }, 300);

    const fetchApologyMembersData = useAsyncDebounce(async() => {
        try {
            let resp = await CommitteeService.SearchMembers(aplogiesMembersSearchRequest);
            if (resp.data) {
                setApologiesMembersData(resp.data.results);

            }
        } catch (error) {
            console.log(error);
        } 
    }, 300);

    const committeeMinutesLog = async (actionType: number, actionDescription: string) => {
        await UserActivityService.createActivityLog({
            section: CommitteeMinutesSection,
            actionType: actionType,
            actionDescription: actionDescription,
            scorecardId: props.scorecardId,
            requestUrl: window.location.href
        });
    }

    const handleDataSubmit: SubmitHandler<CommitteeMinutes.DtoOut> = async (minutes: CommitteeMinutes.DtoOut) => {
        minutes.date = offsetTimezone(minutes.date);
        try {
            if (!minutesId) {
                const result = await CommitteeService.CreateMinutes(minutes);
                committeeMinutesLog(UserActivityActionType.Create, "Add minutes");
                toast.success("Minutes added succesfully");
                const saveMinutesId = result.data.id;
                setMinutesId(saveMinutesId);
                setValue("id", saveMinutesId);
                props.setMinutesId(saveMinutesId);
                setMinutesId(saveMinutesId)
            }

            else {
                await CommitteeService.UpdateMinutes(minutes);
                committeeMinutesLog(UserActivityActionType.Update, "Edit minutes");
                toast.success("Minutes saved succesfully")
            }

        } catch (error: any) {
            if(error.response.status === 400)
                toast.error(error.response.data)
        }
    }

    const handleCancel = () => {
        props.handleCancel();
        props.refreshTable();
    }

    const openDocumentsPopUp = () => {
        setDocumentsPopUp(true);
    }

    const saveAgendaItem = () => {
        const agendaList = getValues("agendaItems");
        agendaList.push({agenda: CommitteeMinutesAgenda.Other, agendaText:agendaItemName, agendaDescription:""})
        setValue("agendaItems", agendaList);
        setEnterAgendaItem(false);
        setAgendaItemName("");
    }

    const getMinutes = async (id: string) => {
        try {
            const result = await CommitteeService.GetMinutes(id);
            var member =
                {
                    id: result.data.id,
                    scorecardId: props.scorecardId,
                    date: new Date(new Date(result.data.date).toDateString()),
                    committeeType: result.data.committeeType,
                    agendaItems: result.data.agendaItems
                } as CommitteeMinutes.DtoOut
            member.attendees = result.data.attendees.map(x => x.id);
            member.apologies = result.data.apologies.map(x => x.id);
            reset(member);
            setAttendeesData(result.data.attendees);
            setApologiesData(result.data.apologies);


        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (minutesId) {
            getMinutes(minutesId);
        }
        fetchAttendeeMembersData();
        fetchApologyMembersData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [attendeeMemberSearchValue, apologyMemberSearchValue]);


    return (
        <>
        <Box >
            <Dialog open={props.previewPopup} onClose={handleCancel} aria-labelledby="form-dialog-title" maxWidth='md' fullWidth>
                <CustomDialogTitle id="customized-dialog-title" onClose={handleCancel}>
                    {props.id !== undefined? "Edit Minutes" : "Add Minutes"}
                </CustomDialogTitle>
                <DialogContent>
                    <Grid container justifyContent='center' sx={{ my: 2 }}>
                        <Grid item xs={10} lg={10}>
                            <Box component="form"  id='CommitteeMinutesForm' onSubmit={handleSubmit(handleDataSubmit)}>
                                <MDBox>
                                    <MDBox mb={1}>
                                        <Grid item xs={12}>
                                            <MDBox mb={2}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <FormControl fullWidth>
                                                        <Controller
                                                            control={control}
                                                            name="date"
                                                            render={({ field: { onChange, value } }) => (
                                                                <ValidatedMobileDatePicker
                                                                    inputFormat="yyyy/MM/dd"
                                                                    mask="____/__/__"
                                                                    label="Date *"
                                                                    value={value}
                                                                    onChange={(date: Date) => {           
                                                                        if (date != null) {
                                                                            onChange(getDateWithoutTime(date));
                                                                            setValue("date", getDateWithoutTime(date));
                                                                        }
                                                                    }}
                                                                    renderInput={(params: any) => <TextField {...params}
                                                                        error={!!errors.date}
                                                                        helperText={errors.date?.message}
                                                                    />
                                                                    }
                                                                    views={['year', 'month', 'day']}
                                                                />
                                                            )}
                                                        />
                                                        </FormControl>
                                                    </LocalizationProvider>
                                                </MDBox>
                                            <MDBox mb={2}>
                                                <Controller
                                                    control={control}
                                                    name="attendees"
                                                    render={({ field: { onChange, value } }) => (
                                                        <Autocomplete
                                                            multiple
                                                            options={attendeeMembersData}
                                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                                            value={attendeesData}
                                                            getOptionLabel={option => option.fullName}
                                                            onChange={(e: any, newValue: any) => {
                                                                if(newValue){
                                                                    const list: string[] = [];
                                                                    const attendeeList: CommitteeMember.DtoIn[] = [];
                                                                    newValue?.forEach((element: CommitteeMember.DtoIn) => {
                                                                        list.push(element.id);
                                                                        attendeeList.push(element);
                                                                    });
                                                                    onChange(list);
                                                                    setValue("attendees", list);
                                                                    setAttendeesData(attendeeList);
                                                                }
                                                            }}
                                                            renderOption={(props, option) => {
                                                                return (
                                                                    <li {...props} key={option.id}>
                                                                        {option.fullName}
                                                                    </li>
                                                                );
                                                            }}
                                                            renderInput={(params) =>
                                                                <TextField label='Attendees *' {...params} type='text'
                                                                    error={!!errors.attendees}
                                                                    helperText={(errors.attendees as any)?.message}
                                                                    variant="standard"
                                                                    onChange={(e: any) => {
                                                                        if(e.target.value !== null){
                                                                            setAttendeeMemberSearchValue(e.target.value);
                                                                        }
                                                                    }}
                                                                />
                                                            }
                                                        />
                                                    )}
                                                />
                                            </MDBox>
                                            <MDBox mb={2}>
                                                <Controller
                                                    control={control}
                                                    name="apologies"
                                                    render={({ field: { onChange, value } }) => (
                                                        <Autocomplete
                                                            multiple
                                                            options={apologiesMembersData}
                                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                                            value={apologiesData}
                                                            getOptionLabel={option => option.fullName}
                                                            onChange={(e: any, newValue: any) => {
                                                                if(newValue){
                                                                    const list: string[] = [];
                                                                    const apologyList: CommitteeMember.DtoIn[] = [];
                                                                    newValue?.forEach((element: CommitteeMember.DtoIn) => {
                                                                        list.push(element.id);
                                                                        apologyList.push(element);
                                                                    
                                                                    });
                                                                    onChange(list);
                                                                    setValue("apologies", list);
                                                                    setApologiesData(apologyList);
                                                                }
                                                            }}
                                                            renderOption={(props, option) => {
                                                                return (
                                                                    <li {...props} key={option.id}>
                                                                        {option.fullName}
                                                                    </li>
                                                                );
                                                            }}
                                                            renderInput={(params) =>
                                                                <TextField label='Apologies' {...params} type='text'
                                                                    error={!!errors.apologies}
                                                                    helperText={(errors.apologies as any)?.message}
                                                                    variant="standard"
                                                                    onChange={(e: any) => {
                                                                        if(e.target.value !== null){
                                                                            setApologyMemberSearchValue(e.target.value);
                                                                        }
                                                                    }}
                                                                />
                                                            }
                                                        />
                                                    )}
                                                />
                                            </MDBox>
                                            <MDBox mb={2}>
                                                <Controller
                                                    control={control}
                                                    name="agendaItems"
                                                    render={({ field: { onChange, value } }) => (
                                                        <Autocomplete
                                                            multiple
                                                            options={agendaItemOptions}
                                                            isOptionEqualToValue={(option, value) => option.agenda === value.agenda && option.agendaText === value.agendaText}
                                                            value={value}
                                                            getOptionLabel={option => option.agenda === CommitteeMinutesAgenda.Other? (option.agendaText !== null? option.agendaText: ""): option.agendaDescription }
                                                            onChange={(e: any, newValue: any) => {
                                                                if(newValue){
                                                                    if(newValue[newValue.length - 1]?.agenda === CommitteeMinutesAgenda.Other && newValue?.length > getValues("agendaItems").length){
                                                                        setEnterAgendaItem(true);
                                                                    }
                                                                    else{
                                                                        const list: CommitteeMinutes.Agenda[] = [];
                                                                        newValue?.forEach((element: CommitteeMinutes.Agenda) => {
                                                                            list.push(element);
                                                                        
                                                                        });
                                                                        onChange(list);
                                                                        setValue("agendaItems", list);
                                                                        
                                                                    }
                                                                }
                                                            }}
                                                            renderOption={(props, option) => {
                                                                return (
                                                                    <li {...props} key={option.agenda}>
                                                                        {option.agendaDescription}
                                                                    </li>
                                                                );
                                                            }}
                                                            renderInput={(params) =>
                                                                <TextField label='Agenda *' {...params} type='text'
                                                                    error={!!errors.agendaItems}
                                                                    helperText={(errors.agendaItems as any)?.message}
                                                                    variant="standard"
                                                                />
                                                            }
                                                        />
                                                    )}
                                                />
                                            </MDBox>
                                            {enterAgendaItem && 
                                                <MDBox mb={2}>
                                                    <TextField value={agendaItemName} InputLabelProps={{ shrink: true }}  type='text' 
                                                                label='Enter Agenda Item Name' fullWidth variant="standard" size="small" 
                                                                onChange={e => setAgendaItemName(e.target?.value)}
                                                                InputProps={{endAdornment:
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            aria-label="close"
                                                                            onClick={() => {
                                                                                setEnterAgendaItem(false);
                                                                                setAgendaItemName("");}}
                                                                            edge="end"
                                                                        >
                                                                        <CloseIcon />
                                                                        </IconButton>
                                                                     </InputAdornment>
                                                                }}
                                                            />
                                                    <MDBox mt={1}>
                                                        <MDButton variant="contained" color="secondary" onClick={saveAgendaItem} size="small">
                                                            Save Name
                                                        </MDButton>
                                                    </MDBox>
                                                </MDBox>}
                                        </Grid>
                                    </MDBox>
                                </MDBox>
                            </Box>
                        </Grid>
                    </Grid>
                    {minutesId !== undefined && <SupportingDocuments display={documentsPopUp} handleCancel={() => setDocumentsPopUp(false)} link={props.link} id={minutesId} 
                        scorecardId={props.scorecardId} isEEModule={true} section={CommitteeMinutesSection} attachedFile={true}/>}
                </DialogContent>
                <DialogActions>
                    {minutesId !== undefined &&
                        <MDButton variant="contained" color="primary" onClick={openDocumentsPopUp} startIcon={<AttachFileIcon />}
                            size="medium">
                            Attach File
                        </MDButton>
                    }
                    <LoadingButton variant='contained' color='primary' type='submit' form='CommitteeMinutesForm' loading={isSubmitting}>
                        Save
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </Box>

    </>);
}
